import { render, staticRenderFns } from "./IssueOrder.vue?vue&type=template&id=b66ca43a"
import script from "./IssueOrder.vue?vue&type=script&lang=js"
export * from "./IssueOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports